import { render, staticRenderFns } from "./CustomSwitchFilterNew.vue?vue&type=template&id=9352b886&scoped=true&"
import script from "./CustomSwitchFilterNew.vue?vue&type=script&lang=js&"
export * from "./CustomSwitchFilterNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomSwitchFilterNew.vue?vue&type=style&index=0&id=9352b886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9352b886",
  null
  
)

export default component.exports